<div class="progress-bar-wrapper" [class.bold]="type() === 'bold'">
  <div class="progress-best-score" [style.width.%]="clampedBestScore()"></div>
  <div class="progress-current-score" [style.width.%]="clampedCurrentScore()"></div>
</div>
